export default __webpack_public_path__ + "static/UofT-02beeef81e216c1540625cca3ec5680b.png";